import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
// Import Containers
import {
    FullLayoutComponent,
    SimpleLayoutComponent
} from './containers';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: '',
        component: FullLayoutComponent,
        data: {
            title: 'MENU.HOME'
        },
        children: [
            {
                path: 'dashboard',
                canActivate: [AuthGuard],
                loadChildren: './views/dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'plant_lists',
                canActivate: [AuthGuard],
                loadChildren: './views/plant_lists/plant_lists.module#Plant_listsModule'
            },
            {
                path: 'device_monitoring',
                canActivate: [AuthGuard],
                loadChildren: './views/device_monitoring/device_monitoring.module#Device_monitoringModule'
            },
            {
                path: 'users',
                canActivate: [AuthGuard],
                loadChildren: './views/users/users.module#UsersModule'
            },
            {
                path: 'installers',
                canActivate: [AuthGuard],
                loadChildren: './views/installer/installers.module#InstallersModule'
            },
            {
                path: 'distributors',
                canActivate: [AuthGuard],
                loadChildren: './views/distributor/distributors.module#DistributorsModule'
            },
            {
                path: 'clients',
                canActivate: [AuthGuard],
                loadChildren: './views/clients/clients.module#ClientsModule'
            },
            {
                path: 'alarm_codes',
                canActivate: [AuthGuard],
                loadChildren: './views/alarm_code/alarm_codes.module#Alarm_codesModule'
            },
            {
                path: 'setting',
                data: {
                    title: 'MENU.SETTING'
                },
                children: [
                    {
                        path: 'permission_categorys',
                        canActivate: [AuthGuard],
                        loadChildren: './views/setting/permission_category/permission_category.module#Permission_categoryModule'
                    },
                    {
                        path: 'permissions',
                        canActivate: [AuthGuard],
                        loadChildren: './views/setting/permission/permission.module#PermissionModule'
                    },
                    {
                        path: 'roles',
                        canActivate: [AuthGuard],
                        loadChildren: './views/setting/role/role.module#RoleModule'
                    },
                ]
            },
            {
                path: 'mqtt',
                data: {
                    title: 'MENU.MQTT'
                },
                children: [
                    {
                        path: 'commands_list',
                        canActivate: [AuthGuard],
                        loadChildren: './views/mqtt/commands_list_view/commands-list-view.module#CommandsListViewModule'
                    },
                    {
                        path: 'send_commands',
                        canActivate: [AuthGuard],
                        loadChildren: './views/mqtt/send_commands_view/send-commands-view.module#SendCommandsViewModule'
                    },
                ]
            },
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
        ]
    },
    {
        path: 'login',
        component: SimpleLayoutComponent,
        data: {
            title: 'MENU.LOGIN'
        },
        children: [
            {
                path: '',
                loadChildren: './views/authentication/login/login.module#LoginModule',
            }
        ]
    },
    {
        path: 'forget_password',
        component: SimpleLayoutComponent,
        data: {
            title: 'MENU.FORGET_PASSWORD'
        },
        children: [
            {
                path: '',
                loadChildren: './views/authentication/forget/forget.module#ForgetModule',
            }
        ]
    },
    {
        path: 'register',
        component: SimpleLayoutComponent,
        data: {
            title: 'MENU.REGISTER'
        },
        children: [
            {
                path: '',
                loadChildren: './views/authentication/register/register.module#RegisterModule',
            }
        ]
    },
    {
        path: 'password/reset/:token',
        component: SimpleLayoutComponent,
        data: {
            title: 'MENU.FORGET_PASSWORD'
        },
        children: [
            {
                path: '',
                loadChildren: './views/authentication/reset/reset.module#ResetModule',
            }
        ]
    },
    {
        path: 'active_account/:token',
        component: SimpleLayoutComponent,
        data: {
            title: 'MENU.FORGET_PASSWORD'
        },
        children: [
            {
                path: '',
                loadChildren: './views/authentication/activate_account/activate_account.module#Activate_accountModule',
            }
        ]
    },
    {
        path: '404',
        component: SimpleLayoutComponent,
        data: {
            title: 'MENU.ERROR404'
        },
        children: [
            {
                path: '',
                loadChildren: './views/error/404.module#P404Module',
            }
        ]
    },
    {
        path: '**',
        redirectTo: '404',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/app.routing.ts